import React from 'react';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import withLoader from '../app/withLoader';
import { withRouter } from 'react-router-dom';
import ChangePasswordForm from './changePasswordForm';
import ChangeSettingsForm from './changeSettingsForm';
import { changePassword, getCompanyDetails, updateCompanyDetails } from './_api';
import { get } from 'lodash';
import { withSnackbar } from 'notistack';
import { Tab, Tabs } from '@material-ui/core';
import ChangeQRForm from './changeQRForm';

const styles = (theme) => ({
  root: {
    margin: 20,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
});

const enhance = compose(
  withStyles(styles),
  withState('activeTab', 'setActiveTab', 'settings'),
  withState('initialValuesForSettings', 'setInitialValuesForSettings', {}),
  withSnackbar,
  withLoader,
  withRouter,
  withHandlers({
    onChangePassword:
      ({ toggleLoader, history, enqueueSnackbar }) =>
      async (values) => {
        toggleLoader();
        const resp = await changePassword(values.oldPassword, values.newPassword1);
        if (get(resp, 'success', false)) {
          enqueueSnackbar('Heslo bylo úspěšně změněno.', { variant: 'success' });
          history.push('/');
        } else {
          enqueueSnackbar('Heslo se nepodařilo změnit.', { variant: 'error' });
        }

        toggleLoader(false);
      },
    onUpdateCompany:
      ({ toggleLoader, enqueueSnackbar, history }) =>
      async (values) => {
        toggleLoader();
        try {
          await updateCompanyDetails(values);
          toggleLoader(false);
          enqueueSnackbar('Úspěšně upraveno', { variant: 'success' });
          history.push('/');
        } catch (e) {
          toggleLoader(false);
          enqueueSnackbar('Chyba při upravování', { variant: 'error' });
        }
      },
    handleTabChange:
      ({ setActiveTab }) =>
      async (event, value) => {
        setActiveTab(value);
      },
  }),
  lifecycle({
    async componentDidMount() {
      const resp = await getCompanyDetails();
      this.props.setInitialValuesForSettings(resp);
    },
  })
);

export default enhance(
  ({
    classes,
    attribute,
    onChangePassword,
    onUpdateCompany,
    activeTab,
    handleTabChange,
    initialValuesForSettings,
  }) => (
    <div>
      <div className={classes.root}>
        <Tabs value={activeTab} onChange={handleTabChange} scrollButtons="auto">
          <Tab key="settings" label="Nastavení uživatele" value="settings" />
          <Tab key="password" label="Změna hesla" value="password" />
          <Tab key="qr" label="Nastavení QR" value="qr" />
        </Tabs>
        <Paper
          className={classes.paper}
          style={activeTab === 'settings' ? { display: 'block' } : { display: 'none' }}
        >
          <ChangeSettingsForm initialValues={initialValuesForSettings} onSubmit={onUpdateCompany} />
        </Paper>
        <Paper
          className={classes.paper}
          style={activeTab === 'password' ? { display: 'block' } : { display: 'none' }}
        >
          <ChangePasswordForm onSubmit={onChangePassword} />
        </Paper>
        <Paper
          className={classes.paper}
          style={activeTab === 'qr' ? { display: 'block' } : { display: 'none' }}
        >
          <ChangeQRForm />
        </Paper>
      </div>
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/modules/account/index.js